import { render, staticRenderFns } from "./bossBoard.vue?vue&type=template&id=19bfc386&scoped=true&"
import script from "./bossBoard.vue?vue&type=script&lang=js&"
export * from "./bossBoard.vue?vue&type=script&lang=js&"
import style0 from "./bossBoard.vue?vue&type=style&index=0&id=19bfc386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfc386",
  null
  
)

export default component.exports